import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import {
  FIELD_MEMBER_SELECTED,
  FIELD_MEMBERS,
  FIELD_SET_COMMON_PAY_FREQUENCY,
  FIELD_TEXT_REQUIRED,
  WAGES_AND_INCOME_COMMON_FIELD_NAMES,
} from './constants.fields';
import { FormattedMessage } from 'react-intl';
import { getDisabledMembers } from 'pages/AffordaWagesAndIncome/utils';

export const MAX_RECORDS_BY_USER = 1;

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.online.title',
  description: 'afforda.wagesAndIncome.details.online.subtitle',
  addButton: 'afforda.wagesAndIncome.details.online.add',
  addCaption: 'afforda.wagesAndIncome.details.online.addDescription',
};

export const ONLINE_FIELD_NAMES = {
  annualAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
  memberId: WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
  monthlyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
  payFrequency: WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
  source: WAGES_AND_INCOME_COMMON_FIELD_NAMES.source,
  weeklyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    annualAmount: item.annualAmount ?? '',
    monthlyAmount: item.monthlyAmount ?? '',
    payFrequency: item.payFrequency ?? '',
    source: item.source ?? '',
    weeklyAmount: item.weeklyAmount ?? '',
  };
};

export const getFormProps = ({ items, memberId }) => {
  return {
    disabledMembers: getDisabledMembers(items, memberId, MAX_RECORDS_BY_USER),
  };
};

export const NEW_ONLINE = {
  annualAmount: '',
  memberId: '',
  monthlyAmount: '',
  payFrequency: '',
  source: '',
  weeklyAmount: '',
};

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),

    // Source
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_TEXT_REQUIRED,
      label: <FormattedMessage id="afforda.wagesAndIncome.details.sources" />,
      placeholder: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.sources',
      }),
      InputLabelProps: {
        TooltipProps: {
          title: (
            <FormattedMessage id="afforda.wagesAndIncome.details.online.sources" />
          ),
          children: <AlertInfoIcon fontSize={'small'} />,
        },
      },
      name: ONLINE_FIELD_NAMES.source,
    },

    // Pay Frequency
    ...FIELD_SET_COMMON_PAY_FREQUENCY,
  ];
};
